import type { LocationData } from "../../../mocks/locationData";

interface LocationFacilitiesProps {
  location: LocationData;
}

export default function LocationFacilities({ location }: LocationFacilitiesProps) {
  return (
    <section className="bg-cl-tint py-20 px-6 lg:px-10">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-14 items-start">
          {/* Left: facilities list */}
          <div className="flex-1">
            <p className="text-xs font-black text-cl-green uppercase tracking-widest mb-2">Local Recycling</p>
            <h2 className="text-3xl md:text-4xl font-black text-cl-dark leading-tight mb-4">
              Waste Facilities Near <span className="text-cl-green">{location.city}</span>
            </h2>
            <p className="text-gray-500 font-semibold mb-8 max-w-lg">
              Cleario works with licensed {location.city}-area waste processors and recycling centres to handle your waste responsibly.
            </p>

            <div className="flex flex-col gap-4">
              {location.facilities.map((facility) => (
                <div
                  key={facility.name}
                  className="bg-white rounded-2xl p-5 thick-border cartoon-shadow flex items-start gap-4"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-green flex-shrink-0 mt-0.5">
                    <i className="ri-recycle-line text-xl text-cl-dark"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-cl-dark font-black text-sm">{facility.name}</p>
                    <p className="text-gray-500 text-xs font-semibold mt-0.5">{facility.address}</p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="bg-cl-tint text-cl-dark text-xs font-black px-2.5 py-1 rounded-full border border-cl-green">
                        {facility.type}
                      </span>
                      <span className="text-gray-400 text-xs font-semibold flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>
                        {facility.distance} from centre
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: map embed */}
          <div className="w-full lg:w-[420px] flex-shrink-0">
            <div className="rounded-2xl overflow-hidden thick-border cartoon-shadow h-[350px]">
              <iframe
                title={`Map of ${location.city}`}
                src={location.mapEmbed}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="mt-4 bg-white rounded-2xl p-4 thick-border cartoon-shadow flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-green flex-shrink-0">
                <i className="ri-map-pin-2-fill text-cl-dark text-sm"></i>
              </div>
              <div>
                <p className="text-cl-dark font-black text-sm">Serving all {location.county} areas</p>
                <p className="text-gray-500 text-xs font-semibold">No minimum job size — single items welcome</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
